import React from "react";
import { RouteComponentProps } from "react-router";
import { store } from "@store";
import { nodeRefToUri } from "@clientUtils";
import CustomerSearch from "./CustomerSearch/CustomerSearch";
import { CUSTOMER_SLIDER } from "../navigation/locations";
import { CustomerEditorLocation } from "../navigation/locations/CustomerEditorLocation";
import { CustomerProfileLocation } from "../navigation/locations/CustomerProfileLocation";
import { checkIfDirectRoute } from "@utils/navigationUtils";

type Props = RouteComponentProps<any>;

export function CustomerSearchPage(props: Props) {
  const { history, match } = props;
  const { url } = match;

  const { navigation } = store();

  return (
    <>
      {catchDirectUrl(url)}
      <CustomerSearch
        onCustomerOpen={(id) =>
          navigation.open(CUSTOMER_SLIDER, new CustomerProfileLocation(id))
        }
        onNewItem={() =>
          navigation.open(CUSTOMER_SLIDER, new CustomerEditorLocation(null))
        }
        onNodeClick={(nodeRef) => history.push(`${url}/${nodeRefToUri(nodeRef)}`)}
      />
    </>
  );
}

function catchDirectUrl(url) {
  return checkIfDirectRoute(
    `${url}/:id?/:action?/:id2?`,
    CUSTOMER_SLIDER,
    ({ id, action, id2 }) => {
      if (id === "new") {
        return new CustomerEditorLocation(null);
      }

      if (id) {
        let groupId;
        if (action === "group" && id2) {
          groupId = id2;
        }
        return new CustomerProfileLocation(id, groupId);
      }
    }
  );
}
